import { combineReducers } from "redux";

import userReducer from "./user";
import appReducer from "./app";
import postReducer from "./post";
import commentReducer from "./comment";
import messageReducer from "./message";
import searchReducer from "./search";
import talentReducer from "./talent";
import freePostReducer from "./freePost";
import apkReducer from "./apk";
import iosReducer from "./ios";
import wordingReducer from "./wording";

const rootReducer = combineReducers({
  user: userReducer,
  app: appReducer,
  post: postReducer,
  comment: commentReducer,
  message: messageReducer,
  search: searchReducer,
  talent: talentReducer,
  freePost: freePostReducer,
  apk: apkReducer,
  ios: iosReducer,
  wording: wordingReducer,
});

export default rootReducer;
